import axios from 'axios'
import {DownloadFile, SearchUrlParamBuilder} from '@/core/utils'

const URL_PATH = 'api/fiscais'

class FiscaisApiClient {
	async buscarFiscais(paginacao, filtros) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtros,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(URL)
	}

	async excluirFiscal(idFiscal) {
		let URL = `${URL_PATH}/${idFiscal}`
		return await axios.delete(URL)
	}

	async adicionarFiscal(objParam) {
		return await axios.post(`${URL_PATH}/inserir`, objParam)
	}

	async buscarUsuariosFiscais(objParam) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/usuarios`,
			filters: objParam,
		}).build()

		return await axios.get(`${url}`)
	}

	async buscarOrgaos(objParam) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/orgaos`,
			filters: objParam,
		}).build()

		return await axios.get(`${url}`)
	}

	async buscarAnexos(idFiscal) {
		const URL = `${URL_PATH}/${idFiscal}/anexos`
		return await axios.get(URL)
	}

	async baixarAnexo(idFiscal, idExterno) {
		const URL = `${URL_PATH}/${idFiscal}/anexos/${idExterno}/baixar`
		const response = await axios.get(URL, {
			responseType: 'arraybuffer',
		})
		const headers = response.headers
		const extension = headers.extension
		const filename = headers.filename.replace(`.${extension}`, '')
		DownloadFile.downloadArrayBuffer(response.data, filename, headers['content-type'], extension)
	}

	async editarFiscal(idFiscal, body) {
		const url = `${URL_PATH}/${idFiscal}`

		return await axios.put(url, body)
	}

	async excluirAnexoFiscal({ idFiscal, idExterno }) {
		return await axios.delete(`${URL_PATH}/${idFiscal}/anexo/${idExterno}`)
	}
}

export default new FiscaisApiClient()
